<bic-popup title="Neuer Ordner" (close)="cancelClicked()" customClass="w-[560px]">
  <div bicPopupContent [formGroup]="folderForm">
    <bic-input [errorCondition]="showValidationError" [formControlName]="'folderName'" [iconStart]="faPenToSquare"
               [label]="'Name'" [maxLength]="32" [placeholder]="'Ordner-Name * (erforderlich)'"
               [required]="true" [showX]="false" class="w-full"></bic-input>
    <!-- Vorher war der Speichern-Button nur ausgegraut: unerlaubtes Zeichen, Dublette und leerer
         Name sahen identisch aus und es gab keinen Hinweis, warum es nicht weitergeht. -->
    @if (showValidationError) {
      <span class="block mt-2 text-sm text-red-500">{{ validationError }}</span>
    }
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
    <bic-button (onClick)="cancelClicked()" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="saveClicked()" [disabled]="!isUniqueName()">Speichern</bic-button>
  </div>
</bic-popup>

